import {
  BaseTextFieldProps,
  InputBaseProps,
  TextField,
} from "@material-ui/core"
import styled from "styled-components"

const Styled = {
  Field: styled(TextField)<{ $center?: boolean }>`
    width: 100%;
    .MuiFormHelperText-root {
      font-size: 15px;
    }
    .MuiFormHelperText-root.Mui-error {
      ${(p) => (p.$center ? `text-align: center;` : ``)}
    }
    input {
      ${(p) => (p.$center ? `text-align: center;` : ``)}
    }
  `,
}

export interface CommonInputProps extends BaseTextFieldProps {
  name: string
  label?: string
  type?: "text" | "email" | "tel" | "number" | "date"
  required?: boolean
  maxLength?: number
  placeholder?: string
  numeric?: boolean
  InputProps?: InputBaseProps
  centerField?: boolean
  autoFocus?: boolean
  inputRef?: any
  variant?: "outlined" | "standard" | "filled"
  onChange: (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    name: string
  ) => void
}

const MuiInput = ({
  name,
  label,
  type = "text",
  required = false,
  autoFocus,
  variant = "standard",
  onChange,
  inputRef,
  ...props
}: CommonInputProps) => {
  return (
    <Styled.Field
      id={name}
      name={name}
      helperText={props.helperText}
      error={props.error}
      label={label}
      fullWidth
      type={type}
      required={required}
      autoFocus={autoFocus}
      variant={variant}
      ref={inputRef}
      onChange={(e) => {
        onChange(e, name)
      }}
      {...props}
    />
  )
}

export default MuiInput
